import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
// import classes from './ProjectPicker.scss'
import _ from 'lodash';

const mapActionCreators = {};

const mapStateToProps = state => ({
  projects: state.project.projects,
});

class ProjectPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.default,
    };
  }

  componentWillMount() {}

  setValue = value => {
    // // console.log('set value!')
    this.setState({ value });

    const val = value === null ? null : value.value;

    this.props.onChange({
      target: {
        name: this.props.name,
        value: val,
      },
    });
  };

  render() {
    const props = this.props;

    const placeholder = <span>Projekt wählen</span>;
    // const allData = props.projects;
    const selectData = [];

    const allData = _.orderBy(props.projects, ['projectPickerName'], ['asc']);

    // console.log(this.props.default);

    _.forOwn(allData, data => {
      // create new object that will be handled by griddle
      if (
        (typeof data.id !== 'undefined' && data.deleted_at === null) ||
        (typeof data.id !== 'undefined' &&
          this.state.value !== null &&
          this.state.value.value === data.id)
      ) {
        if (data.id !== this.props.omit) {
          selectData.push({
            value: data.id,
            title: data.projectPickerName,
            label: data.projectPickerName,
          });
        }
      }
    });
    return (
      <div className="section">
        <Select
          onChange={this.setValue}
          options={selectData}
          placeholder={placeholder}
          value={this.state.value}
        />
      </div>
    );
  }
}
ProjectPicker.propTypes = {
  name: PropTypes.string,
  default: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  onChange: PropTypes.func,
  omit: PropTypes.string,
};
export default connect(mapStateToProps, mapActionCreators)(ProjectPicker);



// WEBPACK FOOTER //
// ./src/components/ProjectPicker/ProjectPicker.js